import {observable, action, computed, createTransformer, reaction} from "mobx";
import TarefaService from "../../../services/TarefaService";
import axios, {post} from 'axios';
import {token, baseUrl, http} from "../../../config/Constantes";
import _ from "lodash";

export default class TarefasHorasExtrasStore {

    @observable tarefas;
    @observable loading;
    @observable importModal;
    @observable files;
    @observable rejectedfiles;
    @observable invalidFilesMsgs;
    @observable errorMensage;
    @observable isLoading;
    @observable sucessoImportacao;
    @observable errorsImportacao;
    @observable observacoes;

    constructor() {
        this.isLoading = false;
        this.importModal = false;
        this.files = [];
        this.rejectedfiles = [];
        this.errorMensage = "";
        this.tarefas = [];
        this.sucessoImportacao = [];
        this.errorsImportacao = [];
        this.tarefaService = new TarefaService();
        this.observacoes = "";
    }

    toogleImportModal() {
        this.files = [];
        this.rejectedfiles = [];
        this.sucessoImportacao = [];
        this.errorsImportacao = [];
        this.isLoading = false;
        this.importModal = !this.importModal;

        // Limpar backdrop quando modal fecha (importModal passa de true para false)
        if (!this.importModal) {
            this.limparBackdropDoBody();
        }
    }

    // Remove classes de backdrop do body e elementos residuais do DOM
    // Chamado quando modal fecha para evitar overlay stacking
    limparBackdropDoBody() {
        // Usar setTimeout pequeno para garantir que React finalizou a atualização
        setTimeout(() => {
            const possuiModalAberta = document.querySelector('.modal.in, .modal.show');
            if (possuiModalAberta) {
                return;
            }

            const body = document.querySelector('body');
            if (body) {
                // Remove ambas as classes de modal
                body.classList.remove('ReactModal__Body--open');
                body.classList.remove('modal-open');
                // Restaura padding-right removido pelo Modal
                body.style.paddingRight = '';
                if (!body.style.cssText.trim()) {
                    body.removeAttribute('style');
                }
            }
            
            // Neutraliza backdrops residuais sem removê-los do DOM, evitando conflito com o React.
            const backdrops = document.querySelectorAll('.modal-backdrop');
            backdrops.forEach(backdrop => {
                backdrop.classList.remove('show');
                backdrop.classList.remove('in');
                backdrop.style.display = 'none';
                backdrop.style.opacity = '0';
                backdrop.style.pointerEvents = 'none';
                backdrop.setAttribute('aria-hidden', 'true');
            });
            
            // Oculta overlays do ReactModal residuais
            const overlays = document.querySelectorAll('.ReactModal__Overlay');
            overlays.forEach(overlay => {
                overlay.style.display = 'none';
                overlay.style.pointerEvents = 'none';
            });
        }, 0);
    }

    @computed
    get acoesMultiplas() {
        return (_.find(this.tarefas, {definicaoTarefaId: "HT_LancarHorasExtrasETT"}) || _.find(this.tarefas, {definicaoTarefaId: "HT_AjustarHorasExtrasETT"}))
            ? ["importar", "enviarTimesheet"]
            : _.find(this.tarefas, {definicaoTarefaId: "HT_AvaliarHorasExtrasGestor"}) ? ["delegar", "aprovarTimesheet"] : [];
    }

    pushFiles(files) {

        files.accepted.map(
            file => {
                if (_.endsWith(file.name, '.xlsx') || _.endsWith(file.name, '.xls')) {
                    this.files.push(file);
                } else {
                    this.rejectedfiles.push(file);
                }
            }
        );

        files.rejected.map(
            refile => {
                this.rejectedfiles.push(refile);
            }
        );
    }

    cleanFiles() {
        this.files = [];
        this.rejectedfiles = [];
        this.sucessoImportacao = [];
        this.errorsImportacao = [];
        this.errorMensage = "";
    }

    listaDeArquivosVazia() {
        return this.files.length === 0;
    }

    carregarLista() {
        this.loading = true;
        const loadingPromises = Promise.all([
            this.tarefaService.listHorasExtrasPendentes().then(response => {
                this.tarefas = response.data;
            }).catch(error => {
                console.log(error);
            })
        ]);
        loadingPromises.then(
            () => {
                this.loading = false;
            }
        ).catch(
            (error) => this.loading = false
        )
    }

    setLista(value) {
        this.tarefas = value;
    }

    sendFiles() {
        let bsurl = baseUrl;

        if (baseUrl.indexOf("/api") != -1) {
            bsurl = bsurl.toString().replace("/api", "");
        }

        if (baseUrl.indexOf("/sgmot") != -1) {
            bsurl = bsurl.toString().replace("/sgmot", "");
        }

        bsurl = bsurl + '/svc/importarPlanilha';

        this.errorMensage = "";
        if (this.files.length > 0) {
            this.isLoading = true;
            const data = new FormData();
            data.append('file', this.files[0]);

            const url = bsurl;
            const config = {
                headers: {
                    'content-type': 'multipart/form-data'
                }
            }

            post(url, data, config).then(response => {
                    this.rejectedfiles = [];
                    this.sucessoImportacao = [];
                    this.errorsImportacao = [];

                    http.post("/importar", { filePath: response.data.filePath }).then(response => {
                        this.isLoading = false;

                        this.sucessoImportacao = response.data.sucessoImportacao;
                        response.data.lstErrosDadosGerais.map(error => {
                                let erroFormatado = {};
                                erroFormatado.id = error.linha;
                                erroFormatado.plam = "Dados gerais";
                                erroFormatado.label = error.error.join(", ");
                                this.errorsImportacao.push(erroFormatado);
                        });

                        response.data.lstErrosLancamentos.map(error => {
                                let erroFormatado = {};
                                erroFormatado.id = error.linha;
                                erroFormatado.plam = "Lançamentos";
                                erroFormatado.label = error.error.join(", ");
                                this.errorsImportacao.push(erroFormatado);
                        });

                        this.errorMensage = response.data.errorMsg;
                    }
                    ).catch(error => {
                            this.isLoading = false;
                            this.rejectedfiles = [];
                            this.sucessoImportacao = [];
                            this.errorsImportacao = [];
                            this.errorMensage = "Erro de importação!";
                        }
                    );
                }
            ).catch(error => {
                    this.isLoading = false;
                    this.rejectedfiles = [];
                    this.sucessoImportacao = [];
                    this.errorsImportacao = [];
                    this.errorMensage = "Erro de importação!";
                }
            );
        }
        else {
            this.errorMensage = "É necessario selecionar pelo menos 1 arquivo para importação";
        }
    }

}